var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#2B74D8",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96147 18.6233L6.08334 17.7452L11.7933 11.9935L15.1267 15.3269L19.8046 10.7067H17.3333V9.45667H21.9167V14.04H20.6667V11.585L15.1267 17.125L11.7933 13.7917L6.96147 18.6233Z",
    fill: "#2B74D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandBoost);
export default __webpack_public_path__ + "static/media/brand-boost.62af6124d5d255cb236645a6ab5e6d73.svg";
export { ForwardRef as ReactComponent };